module.exports = __webpack_public_path__ + "img/green-bg.371948b5.jpg";